import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";

const tabs = [
    { label: "Announcements", path: "/notifications/announcements" },
    { label: "Stats", path: "/notifications/stats" },
];

export const NotificationsLayout = () => {
    const { pathname } = useLocation();

    // Redirect index to announcements
    if (pathname === "/notifications" || pathname === "/notifications/") {
        return <Navigate to="/notifications/announcements" replace />;
    }

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-bold text-slate-900 dark:text-white">
                    Notifications & Messaging
                </h1>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                    Manage push-oriented communication, broadcast announcements, and delivery performance
                </p>
            </div>

            {/* Tabs */}
            <div className="border-b border-slate-200 dark:border-slate-700">
                <nav className="-mb-px flex gap-6 overflow-x-auto">
                    {tabs.map((tab) => (
                        <NavLink
                            key={tab.path}
                            to={tab.path}
                            className={({ isActive }) =>
                                `whitespace-nowrap border-b-2 px-1 pb-3 text-sm font-medium transition-colors ${isActive
                                    ? "border-primary-600 text-primary-600 dark:border-primary-400 dark:text-primary-400"
                                    : "border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
                                }`
                            }
                        >
                            {tab.label}
                        </NavLink>
                    ))}
                </nav>
            </div>

            <Outlet />
        </div>
    );
};
